/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_012: Question = {
  id: 'gov-012-biodiversite-pdza',
  oldId: '12',
  title: 'Prise en compte de la biodiversité dans le plan de développement de la zone agricole (PDZA)',
  number: '1.12',
  type: QuestionType.ACTIVITY,
  idEM: 1,
  frequency: 1,
  description: [''],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_012_v2: Question = question_gov_012;
export const question_gov_012_v3: Question = question_gov_012;
